import { segment } from '@actions/analytics';
import segmentStorage from '@events/segmentStorage';
import Me from '@models/Me';
import constants, { LOGIN_SUCCESSFUL, SIGNUP_SUCCESFUL } from '../constants';

const sendSegmentEventsPostLogin = ({
  meResp,
  selectedGoalUid,
  selectedGoal,
  query,
  isContentPage,
  routerGoalInfo,
  triggeredFromDetailsPage,
  isLoginTriggeredFromIframe,
  isRegistered,
  loginType,
  country,
  mobileNumber,
  validatedPresetRedirectURL,
  lessonUID,
  youtubePlaylistData,
  experimentData = {},
  selectedCity
}) => {
  const {
    subscription = {},
    expired_at = 'NA',
    time_remaining = 0
  } = Me.getSubscription(
    meResp?.rawResponse?.latest_user_subscriptions_type_wise,
    selectedGoalUid
  ) ?? {};
  const { time_remaining: time_remaining_curr = 0 } =
    Me.getSubscription(
      meResp?.rawResponse?.latest_user_subscriptions_type_wise,
      query?.goalUID
    ) ?? {};
  if (isContentPage && routerGoalInfo) {
    const activeLessonUID =
      lessonUID === '-1'
        ? youtubePlaylistData?.youtubeVideoLessons?.[0]?.id?.toString()
        : lessonUID;
    const activeLesson = youtubePlaylistData?.youtubeVideoLessons?.find(
      (lesson) => lesson.id?.toString() === activeLessonUID
    );
    segment.track('Content page - lead activity', {
      button_text: 'Login',
      source_type: 'content_pages',
      goal_name: routerGoalInfo?.name,
      goal_uid: routerGoalInfo?.uid,
      lesson_name: activeLesson?.title
    });
  }
  segment.track(LOGIN_SUCCESSFUL, {
    ...(experimentData || {}),
    default_goal_uid: selectedGoal?.uid ?? 'NA',
    default_goal_name: selectedGoal?.name ?? 'NA',
    is_new_user: triggeredFromDetailsPage
      ? !isLoginTriggeredFromIframe
      : !isRegistered,
    login_medium: loginType === constants.LOGIN_TYPE_EMAIL ? 'Email' : 'Mobile',
    proxy_id: `${country?.code}${mobileNumber}`,
    default_is_subscription_active: time_remaining > 0,
    default_subscription_duration: subscription.duration,
    default_subscription_end_date: expired_at,
    is_subscription_active: time_remaining_curr > 0,
    login_primary_source: segmentStorage.getItem('lps'),
    last_primary_source_section: segmentStorage.getItem('lpss') || 'NA',
    redirect_to: validatedPresetRedirectURL || 'NA',
    ...(selectedCity && { city: selectedCity })
  });
  if (!isRegistered) {
    segment.track(SIGNUP_SUCCESFUL, {
      default_goal_uid: selectedGoal?.uid ?? 'NA',
      default_goal_name: selectedGoal?.name ?? 'NA',
      is_new_user: triggeredFromDetailsPage
        ? !isLoginTriggeredFromIframe
        : !isRegistered,
      login_medium:
        loginType === constants.LOGIN_TYPE_EMAIL ? 'Email' : 'Mobile',
      proxy_id: `${country?.code}${mobileNumber}`,
      default_is_subscription_active: time_remaining > 0,
      default_subscription_duration: subscription.duration,
      default_subscription_end_date: expired_at,
      is_subscription_active: time_remaining_curr > 0,
      login_primary_source: segmentStorage.getItem('lps'),
      redirect_to: validatedPresetRedirectURL || 'NA'
    });
  }

  if (isLoginTriggeredFromIframe) {
    segment.track('Content page - lead activity', {
      goal_name: selectedGoal?.name ?? 'NA',
      goal_uid: selectedGoal?.uid ?? 'NA',
      source_type: 'content_pages'
    });
  }
};

export default sendSegmentEventsPostLogin;
